module.exports = __webpack_public_path__ + "static/media/miniPC.07f02a22.jpg";